import { ArrowUp } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";
import { CONTACT } from "../lib/data";
import { useLang } from "../lib/i18n";

const ORDER = ["home", "about", "services", "packages", "gallery", "contact"];

export default function Footer() {
  const { lang, t } = useLang();
  return (
    <footer className="relative border-t border-white/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8 relative z-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="text-slate-400 text-sm leading-relaxed mt-5 max-w-sm">{t.footer.desc}</p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">{t.footer.explore}</p>
            <ul className="mt-5 space-y-3">
              {ORDER.map((id) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="text-slate-300 text-sm hover:text-gold transition-colors"
                  >
                    {t.nav.links[id]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">{t.footer.reach}</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a data-testid="footer-phone-link" href={CONTACT.tel} className="text-slate-300 hover:text-gold transition-colors">{CONTACT.phoneDisplay}</a></li>
              <li><a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="text-slate-300 hover:text-gold transition-colors">{CONTACT.email}</a></li>
              <li><a data-testid="footer-whatsapp-link" href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="text-slate-300 hover:text-gold transition-colors">{t.footer.whatsappUs}</a></li>
              <li className="text-slate-500">{CONTACT.hours[lang]}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-white/10">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} OGO Hygiene Solutions · All rights reserved
          </p>
          <button
            data-testid="footer-scroll-top"
            onClick={() => scrollToId("home")}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-300 hover:border-gold hover:text-gold transition-colors"
          >
            {t.footer.backToTop} <ArrowUp size={13} />
          </button>
        </div>
      </div>

      <div className="relative select-none pointer-events-none overflow-hidden -mt-6">
        <p className="font-display font-extrabold text-center leading-[0.8] text-[26vw] text-white/[0.04] tracking-tight">
          OGO
        </p>
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent" />
      </div>
    </footer>
  );
}
